import styled, { css } from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";

export const StyledBackgroundImage = styled.div.attrs(
	({ bgImage, fadeIn, isCropped, coordinates }) => ({
		bgImage: bgImage ? bgImage : "",
		show: fadeIn !== undefined ? fadeIn : false,
		isCropped: isCropped,
		coordinates: coordinates,
	})
)`
	border-radius: ${({ theme }) => theme.border.radius};
	border-bottom-left-radius: ${({ noRadiusBottom }) => (noRadiusBottom ? 0 : "")};
	border-bottom-right-radius: ${({ noRadiusBottom }) => (noRadiusBottom ? 0 : "")};
	max-height: ${({ maxHeight }) => maxHeight};
	background-image: ${(props) => `url(${props.bgImage})`};
	flex-basis: 100%;
	width: 100%;
	display: flex;
	align-items: flex-end;
	height: 100%;
	background-size: cover;
	background-repeat: no-repeat;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.2s ease-in-out;

	${({ isCropped }) =>
		!isCropped &&
		css`
			background-position: 50% center;
		`}

	${({ coordinates }) =>
		coordinates !== undefined &&
		coordinates.x !== undefined &&
		css`
			background-position: ${coordinates.x}% ${coordinates.y}%;

			${media.greaterThan(breakpoints.ipad)`
			background-size: 130%;
		`}
		`}

	${({ show }) =>
		show &&
		css`
			opacity: 1;
		`}
`;

export const Placeholder = styled(StyledBackgroundImage)`
	position: absolute;
`;

export const ImageWrapper = styled.div.attrs(({ height }) => ({
	height: height ? height : "100%",
}))`
	position: relative;
	width: 100%;

	&:before {
		content: "";
		display: block;
		width: 100%;
		padding-bottom: ${({ paddingBottom }) => (paddingBottom ? paddingBottom : "56.25%")};
		overflow: hidden;
	}
	${media.greaterThan(breakpoints.ipad)`
		height: ${(props) => props.height};
	`}
`;
